<template>
  <div class="wrap">
    <!-- 站内信列表页 -->
    <div class="title">个人消息</div>
    <div id="mailPage">
      <div v-if="dataList.length != 0" class="main_content">
        <div v-for="item in dataList" :key="item.inMsgId" class="item_mail">
          <p v-if="item.type == 1" class="dec">
            <span class="circle"></span>
            根据国商订单交易风险控制管理细则，
            您账户的资金风险率高于100%，在电话通知和短信提醒后，未能自行减少订货量或尽快补足可用资金，现于{{
              item.tradeDay
            }}将您{{ item.commodityInfo
            }}{{ item.bsFlag == 1 ? '买' : '卖' }}方向的{{
              item.quantity
            }}手持仓以{{ item.price }}在{{
              item.transferTime | dateFormate
            }}进行代为转让操作，请悉知。
          </p>
          <p v-else class="dec">
            <span class="circle"></span>
            {{ item.note }}
          </p>
          <p class="time">{{ item.createTime | dateFormate }}</p>
        </div>
      </div>
    </div>
    <div v-if="dataList.length == 0" class="main_content noImg">
      <div
        class="no-data-img"
        style="margin: 0 auto; width: 120px; height: 200px;"
      >
        <img
          src="../../assets/images/no_data.png"
          alt=""
          style="width: 100%;"
        >
      </div>
    </div>
    <div style="margin-bottom:20px">
      <el-pagination
        popper-class='_popStyle'
        :current-page="pageData.currentPage"
        :page-sizes="pageData.pageSizes"
        :page-size="pageData.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="pageData.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
  </div>
</template>
<script>
/*global http protocolTrans protocol */
export default {
  data() {
    return {
      dataList: [],
      pageData: {
        total: null,
        pageSizes: [5, 10, 20],
        pageSize: 10,
        currentPage: 1
      }
    }
  },
  mounted() {
    this.isReadFlag()
  },
  methods: {
    // 查询站内信信息
    isReadFlag() {
      protocolTrans.param_transferMsgInfo.param.size = this.pageData.pageSize
      protocolTrans.param_transferMsgInfo.param.page =
        this.pageData.currentPage - 1
      protocolTrans.param_transferMsgInfo.param.readFlag = 'Y'
      http.postFront(protocolTrans.param_transferMsgInfo).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value.content) {
            this.dataList = value.content
            this.pageData.total = value.totalElements
          }
        } else {
          this.$message(message)
        }
      })
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.isReadFlag()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.isReadFlag()
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-pagination .el-select .el-input .el-input__inner,
/deep/.el-pagination button:disabled,
/deep/ .el-pagination .btn-prev,
/deep/ .el-pagination .btn-next,
/deep/ .el-pager li,
/deep/ .el-pagination__editor.el-input .el-input__inner
,/deep/ .el-pagination .el-select .el-input .el-input__inner {
  background-color: #141625 !important;
  border-color: #141625 !important;
}
/deep/ .el-pagination .el-select .el-input .el-input__inner,
/deep/ .el-pagination__editor.el-input .el-input__inner {
    background-color: transparent !important;
    border-color: #DCDFE6 !important;
}
.title {
  width: 100%;
  text-align: center;
  line-height: 100px;
  height: 100px;
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  background-color: #262941;
}
/deep/ .el-pagination button:disabled,/deep/ .el-pagination .btn-prev,/deep/ .el-pagination .btn-next,/deep/ .el-pager li,/deep/ .el-pagination__editor.el-input .el-input__inner,/deep/ .el-pager li{
  background-color: transparent;
}
.main_content {
  min-height: calc(100vh - 205px);
}
.noImg{
  line-height: calc(100vh - 205px);
}
.el-pagination{
      text-align: center;
    }
.wrap{
  background-color: #141625;
  min-height: 100vh !important;
}
#mailPage {
  width: 80%;
  margin: 0 auto;
  .item_mail {
    padding: 30px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    .dec {
      line-height: 26px;
      font-size: 19px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
       color: rgba(255, 255, 255, 0.6);
    }
    .time {
      color: rgba(255, 255, 255, 0.6);
      font-size: 18px;
      text-align: right;
    }
    .circle {
      display: inline-block;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #fa4d55;
    }
  }
  .item_mail:last-child {
    // border-bottom: none;
  }
}
</style>
